/* Land Classics — búsqueda por referencia tolerante a espacios y guiones (tvb 100610 / TVB-100610 → TVB100610) */
(function () {
  function normRef(q) {
    var c = (q || '').trim();
    if (!c || c.split(/\s+/).length > 3) return null;
    var n = c.replace(/[\s\-.\/]+/g, '');
    if (n === c) return null;
    return /^[A-Za-z]{2,4}\d{4,8}[A-Za-z]{0,4}$/.test(n) ? n.toUpperCase() : null;
  }
  // Al enviar cualquier buscador de la tienda
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    var i = f.querySelector('input[name="q"]');
    if (!i) return;
    var n = normRef(i.value);
    if (n) i.value = n;
  }, true);
  // Si se llega a /search con una referencia mal escrita (enlace, historial…)
  if (/\/search\/?$/.test(location.pathname)) {
    var p = new URLSearchParams(location.search), n = normRef(p.get('q'));
    if (n) { p.set('q', n); location.replace(location.pathname + '?' + p.toString()); }
  }
})();
